const MinusIcon = ({ className }) => {
  return (
    <svg
      width="12"
      height="2"
      className={className}
      stroke="currentColor"
      viewBox="0 0 12 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M1.33203 1H10.6654" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default MinusIcon
